export default {
  TITLE: 'Third-Party SDKs',
  CONTENT: `
  <h3>Last Updated: December 1, 2023</h3>
  <p>We may use third-party SDKs to process the personal information we collect, to simplify customer registration, send push notifications, process payments, and gather statistics. These SDKs include:</p>
  <h3>Getui</h3>
  <h3>Affiliated Organization: GeTui Interactive Co., Ltd.</h3>
  <p>Use Case: Push Notifications</p>
  <p>Types of Personal Information Collected: App list information, network and location-related information, device information such as device identifier, platform, and manufacturer to generate a unique push target ID (CID) and device ID (GID)</p>
  <p>Function: Use device information for notification push</p>
  <p>Privacy Protection Statement: <a data-path="https://www.getui.com/privacy">https://www.getui.com/privacy</a></p>
  <h3>WeChat</h3>
  <h3>Affiliated Organization: Shenzhen Tencent Computer Systems Company Limited</h3>
  <p>Use Case: Payment and Login Support</p>
  <p>Types of Personal Information Collected: Commonly used device information</p>
  <p>Function: Use device information to support WeChat payment and login</p>
  <p>Privacy Protection Statement: <a data-path="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl">https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl</a></p>
  <h3>Alipay</h3>
  <h3>Affiliated Organization: Alipay (China) Network Technology Co., Ltd.</h3>
  <p>Use Case: Payment</p>
  <p>Types of Personal Information Collected: Commonly used device information</p>
  <p>Function: Use device information to support Alipay payments</p>
  <p>Privacy Protection Statement: <a data-path="https://render.alipay.com/p/c/k2cx0tg8">https://render.alipay.com/p/c/k2cx0tg8</a></p>
  <h3>TalkingData</h3>
  <h3>Affiliated Organization: Beijing TendCloud Tianxia Technology Co., Ltd.</h3>
  <p>Use Case: Statistical Analysis</p>
  <p>Types of Personal Information Collected: Device information, IP address, IDFA</p>
  <p>Function: Used for statistical analysis of APP behavior</p>
  <p>Privacy Protection Statement: <a data-path="https://www.talkingdata.com/privacy.jsp?languagetype=zh_cn">https://www.talkingdata.com/privacy.jsp?languagetype=zh_cn</a></p>
  <p>SDK Information: <a data-path="https://www.talkingdata.com/safety.jsp?languagetype=zh_cn">https://www.talkingdata.com/safety.jsp?languagetype=zh_cn</a></p>

  <h3>In addition, the following manufacturer SDKs are integrated into Getui SDK, with details as follows:</h3>
  <h3>Xiaomi Push</h3>
  <p>Affiliated Organization: Xiaomi Technology Co., Ltd.</p>
  <p>Use Case: Message push to Xiaomi brand phones</p>
  <p>Types of Personal Information Collected: Software installation list, commonly used device information</p>
  <p>Function: Use device information for notification push</p>
  <p>Privacy Protection Statement: <a data-path="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a></p>

  <h3>VIVO Push</h3>
  <p>Affiliated Organization: Vivo Mobile Communication Co., Ltd.</p>
  <p>Use Case: Message push to VIVO brand phones</p>
  <p>Types of Personal Information Collected: Running processes of this application</p>
  <p>Function: Used by Amazon Overseas Purchase APP to push messages to VIVO phone users</p>
  <p>Privacy Protection Statement: <a data-path="https://dev.vivo.com.cn/documentCenter/doc/652#w1-12075822">https://dev.vivo.com.cn/documentCenter/doc/652#w1-12075822</a></p>

  <h3>OPPO Push</h3>
  <p>Affiliated Organization: Guangdong Oppo Mobile Telecommunications Corp., Ltd.</p>
  <p>Use Case: Message push to OPPO brand phones</p>
  <p>Types of Personal Information Collected: Software installation list, commonly used device information</p>
  <p>Function: Use device information for notification push</p>
  <p>Privacy Protection Statement: <a data-path="https://open.oppomobile.com/new/developmentDoc/info?id=10288">https://open.oppomobile.com/new/developmentDoc/info?id=10288</a></p>

  <h3>Meizu Push</h3>
  <p>Affiliated Organization: Zhuhai Meizu Communications Equipment Co., Ltd.</p>
  <p>Use Case: Message push to Meizu brand phones</p>
  <p>Types of Personal Information Collected: External storage (SD card data), carrier information</p>
  <p>Function: Used by Amazon Overseas Purchase APP to push messages to Meizu phone users</p>
  <p>Privacy Protection Statement: <a data-path="https://static.meizu.com/resources/term/privacy8.html">https://static.meizu.com/resources/term/privacy8.html</a></p>

  <h3>Huawei Push</h3>
  <p>Affiliated Organization: Huawei Software Technologies Co., Ltd.</p>
  <p>Use Case: Message push to Huawei brand phones</p>
  <p>Types of Personal Information Collected: AndroidID, BSSID, network information, carrier information, running processes of this application</p>
  <p>Function: Used by Amazon Overseas Purchase APP to push messages to Huawei phone users</p>
  <p>Privacy Protection Statement: <a data-path="https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177">https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177</a></p>

  <h3>Honor Push</h3>
  <p>Affiliated Organization: Honor Terminal Co., Ltd.</p>
  <p>Use Case: Message push to Honor brand phones</p>
  <p>Types of Personal Information Collected: Running processes of this application</p>
  <p>Function: Used by Amazon Overseas Purchase APP to push messages to Honor phone users</p>
  <p>Privacy Protection Statement: <a data-path="https://developer.hihonor.com/cn/kitdoc?category=%E5%9F%BA%E7%A1%80%E6%9C%8D%E5%8A%A1&kitId=11002&navigation=guides&docId=sdk-data-security.md&token=">https://developer.hihonor.com/cn/kitdoc?category=%E5%9F%BA%E7%A1%80%E6%9C%8D%E5%8A%A1&kitId=11002&navigation=guides&docId=sdk-data-security.md&token=</a></p>
  `
};
